import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from '../services/date-time.service';
import { DateFormat } from '../interfaces/base-core-services.interface';

/**
 * How to use in template
 * {{ date |commondatetime:'datetime'}}-01-Oct-2019 09:59 AM
 * {{ date |commondatetime:'date'}}-01-Oct-2019
 * {{ date |commondatetime:'time'}-09:59 AM
 */
@Pipe({ name: 'commondatetime' })
export class CommonDateTimePipe implements PipeTransform {
  constructor(private dateTimeService: DateTimeService) { }
  transform(datetime: string, datetimename: 'date' | 'time' | 'datetime' | 'datenozone'):any {
    switch (datetimename) {
    case 'date':
      return this.dateTimeService.getDateFormat(datetime, DateFormat.DD_MMM_YYYY);
    case 'time':
      return this.dateTimeService.getDateFormat(datetime, DateFormat.hh_mm_AMPM);
    case 'datetime':
      return this.dateTimeService.getDateFormat(datetime, DateFormat.DD_MMM_YYYY_hh_mm_AMPM);
    case 'datenozone':
      if(datetime && datetime.includes('T'))
        return this.dateTimeService.getDateFormat(datetime.split('T')[0], DateFormat.DD_MMM_YYYY);
      else
        return this.dateTimeService.getDateFormat(datetime, DateFormat.DD_MMM_YYYY);
    default:
      return this.dateTimeService.getDateFormat(datetime, DateFormat.DD_MMM_YYYY);
    }
  }
}
